export default __webpack_public_path__ + "static/media/Buzti_Zaitez_carta.fcdaae92.jpg";